<template>
  <!-- Main Start -->
  <div class="main">
    <section class="page-body p-0">
      <div class="row">
        <div class="order-2 order-lg-1 col-lg-5">
          <div class="content-box">
            <div>
              <h5>Iniciar Sesión</h5>
              <p>Ingresa tus datos al siguiente formulario</p>

              <form action="index.php" class="custom-form form-pill">
                <div class="input-box1">
                  <label for="email">Correo Electrónico</label>
                  <input
                    id="email"
                    name="email"
                    class="form-control"
                    type="email"
                    required
                    v-model="email"
                    inputmode="email"
                    autocomplete="email"
                    autocapitalize="off"
                    spellcheck="false"
                    @keypress="allowEmailKeypress"
                    @paste.prevent="handleEmailPaste"
                    @input="sanitizeEmailOnInput"
                  />
                </div>

                <div class="icon-input">
                  <label for="password">Contraseña</label>
                  <div class="icon-input">
                    <input
                      id="password"
                      name="password"
                      class="form-control"
                      type="password"
                      required
                      v-model="password"
                    />
                    <img class="showHidePassword" src="/assets/icons/svg/eye-1.svg" alt="eye" />
                  </div>
                </div>

                

<!-- <a class="text-decoration-underline theme-color" href="#" @click="toregister()"> ¡Crea una cuenta ahora! </a>  -->     <!-- <a href="#" @click="tohome()" class="">Ir al sitio web </a>
                    -->
  <!-- <div id="g_id_onload"
                      data-client_id="820389707210-noeljepidcc5jh7h7tu3d91rsh7ra99r.apps.googleusercontent.com"
                      data-callback="handleCredentialResponse">
                  </div>
                  <div class="g_id_signin" data-type="standard"></div> -->

                <!--   <span class="line"><span>Or </span> </span>
                <div class="link-group">
                  <a href="https://www.google.com/" class="button-link"><img src="/assets/icons/png/google.png" alt="google" /> Sign in </a>
                  <a href="https://www.facebook.com/" class="button-link"><img src="/assets/icons/png/fb.png" alt="facebook" /> Sign in </a>
                </div> -->
                <router-link :to="'/recuperar-credenciales'" class="forgot-link">¿Olvidaste tu contraseña?</router-link>

                <button type="button" @click="login()" class="btn-solid rounded-pill line-none">Ingresar</button>

                <router-link
                  :to="'/'"
                  class="btn-solid rounded-pill line-none btn-outline mt-3 d-flex justify-content-center"
                >Ir al sitio web</router-link>
              </form>

              <span class="backto-link font-default content-color text-decoration-none">
                Si eres nuevo,
                <router-link :to="'/registro'" class="text-decoration-underline theme-color">¡Crea una cuenta ahora!</router-link>
              </span>
            </div>
          </div>
        </div>

        <div class="order-1 order-lg-2 col-lg-7">
          <div class="img-box">
            <img class="bg-img" src="/assets/images/bg/bg-zd-000.jpg" alt="banner" />
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Main End -->
</template>

<script>
// import FacebookLogin from "vue3-facebook-login";
import myApi from '../../plugins/axios'
import store from '../../plugins/store'
// import VFacebookLogin from 'vue-facebook-login-component'
import { useReCaptcha } from 'vue-recaptcha-v3'

export default {
  name: 'LoginSection',
  components: {
    // VFacebookLogin,
  },
  setup() {
    const { executeRecaptcha } = useReCaptcha()
    return { executeRecaptcha }
  },
  data() {
    return {
      email: null,
      password: null,
      params: {
        scope: 'email profile',
        prompt: 'select_account',
        fetch_basic_profile: true,
      },
      googleSignInParams: {
        client_id: '820389707210-noeljepidcc5jh7h7tu3d91rsh7ra99r.apps.googleusercontent.com'
      },
      gogleIn: {
        email: null,
        name: null,
        surname: null,
        imagen: null,
        google_id: null,
      },
      appId: '274941987794893',
      // solo letras/números y @ . _ + -
      emailAllowedRegex: /[a-zA-Z0-9@._+-]/,
    }
  },

  methods: {
    /* ======================
       RESTRICCIONES DE EMAIL
       ====================== */
    allowEmailKeypress(e) {
      const key = e.key

      // permite teclas de control
      const controlKeys = [
        'Backspace','Delete','ArrowLeft','ArrowRight','ArrowUp','ArrowDown',
        'Home','End','Tab','Enter'
      ]
      if (controlKeys.includes(key)) return

      // no espacios
      if (key === ' ') return e.preventDefault()

      // whitelist
      if (!this.emailAllowedRegex.test(key)) {
        e.preventDefault()
        return
      }

      // evitar segundo '@'
      if (key === '@') {
        const current = this.email || ''
        if (current.includes('@')) {
          e.preventDefault()
        }
      }
    },

    handleEmailPaste(e) {
      const text = (e.clipboardData || window.clipboardData).getData('text') || ''
      this.email = this.normalizeEmail(text)
    },

    sanitizeEmailOnInput(e) {
      const value = e.target.value || ''
      const sanitized = this.normalizeEmail(value)
      if (sanitized !== value) this.email = sanitized
    },

    normalizeEmail(text) {
      // 1) quitar espacios, comillas y especiales típicos
      let cleaned = text
        .replace(/\s+/g, '')                               // sin espacios
        .replace(/['"`<>()[\]{};:\\/|^%$#!?,=~]/g, '')     // limpia especiales
        .split('')
        .filter(ch => this.emailAllowedRegex.test(ch))     // whitelist
        .join('')

      // 2) solo un '@'
      const firstAt = cleaned.indexOf('@')
      if (firstAt !== -1) {
        const before = cleaned.slice(0, firstAt + 1)
        const after = cleaned.slice(firstAt + 1).replace(/@/g, '')
        cleaned = before + after
      }

      // 3) longitud máx razonable
      if (cleaned.length > 254) cleaned = cleaned.slice(0, 254)

      return cleaned
    },

    /* ======================
          NAVEGACIÓN / LOGIN
       ====================== */
    toregister() {
      this.$router.push({ name: 'Register' })
    },
    tohome() {
      this.$router.push({ name: 'Home' })
    },

    async login() {
      try {
        // validación básica de email antes de enviar (opcional)
        if (!this.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
          this.$notify({
            title: 'VALIDACIÓN',
            text: 'Ingresa un correo electrónico válido.',
            duration: 3000,
            type: 'error',
          })
          return
        }

        const payload = {
          email: this.email,
          password: this.password,
          CARTS: [],
          executeRecaptcha: this.executeRecaptcha,
        }

        await store.dispatch('login', payload)
        await store.commit('setPerfilQuery', null)

        this.$notify({
          title: 'EXITO',
          text: 'Bienvenido!',
          duration: 3500,
          type: 'sucess',
        })

        this.$router.push({ name: 'Home' })
      } catch (err) {
        const data = err?.response?.data

        if (err?.response?.status === 423) {
  // Guarda credenciales para auto-login después del OTP
  sessionStorage.setItem('pendingLogin', JSON.stringify({
    email: this.email,
    password: this.password
  }))

  this.$router.push({
    name: 'OtpValidate',
    query: { email: this.email }
  })
  return
}


        if (data?.error) {
          Object.values(data.error).flat().forEach((msg) => {
            this.$notify({
              title: 'VALIDACIÓN',
              text: msg,
              duration: 3500,
              type: 'error',
            })
          })
          return
        }

        this.$notify({
          title: 'VALIDACIÓN',
          text: data?.message || 'Hubo un error al iniciar sesión, inténtalo nuevamente',
          duration: 3500,
          type: 'error',
        })
      }
    },

    // handleLogin(response) {
    //   console.log('User Successfully Logged In', response)
    // },
    // handleLoginFailed() {
    //   console.log('User Cancelled or Abort the Login')
    // },

    decodeJwtResponse(token) {
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(
        window.atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join('')
      )
      return JSON.parse(jsonPayload)
    },

    actualizarMetaetiquetas(titulo, descripcion, imagen, url) {
      const ogTitle = document.querySelector('meta[property="og:title"]')
      const ogDescription = document.querySelector('meta[property="og:description"]')
      const ogImage = document.querySelector('meta[property="og:image"]')
      const ogUrl = document.querySelector('meta[property="og:url"]')
      if (ogTitle) ogTitle.content = titulo
      if (ogDescription) ogDescription.content = descripcion ? descripcion : ''
      if (imagen && ogImage) ogImage.content = imagen
      if (ogUrl) ogUrl.content = url
    },
  },

  mounted() {
    const script2 = document.createElement('script')
    script2.src = '../../assets/js/password-showhide.js'
    document.body.appendChild(script2)
    script2.onload = () => { //console.log('archivo.js cargado 2')//
     }

    this.actualizarMetaetiquetas(
      'Iniciar Sesión',
      'Inicia sesión en tu cuenta para acceder a beneficios exclusivos y realizar un seguimiento de tus compras. ¡Bienvenido de nuevo a Zona Digital!',
      null,
      'https://zonadigitalsv.com/login'
    )

    window.handleCredentialResponse = async (response) => {
      const responsePayload = this.decodeJwtResponse(response.credential)

      this.gogleIn.email = responsePayload.email
      this.gogleIn.name = responsePayload.given_name
      this.gogleIn.surname = responsePayload.family_name
      this.gogleIn.imagen = responsePayload.picture
      this.gogleIn.google_id = responsePayload.sub

      try {
        const resp = await myApi.post('ecommerce/login-google', { google: this.gogleIn })
        if (resp.data.error) {
          for (const key in resp.data.error) {
            this.$notify({
              title: 'VALIDACIÓN',
              text: resp.data.error[key],
              duration: 3500,
              type: 'error',
            })
          }
        } else {
          store.dispatch('saveToken', {
            token: resp.data.token,
            user: resp.data.user,
          })
          setTimeout(() => {
            window.location.href = process.env.VUE_APP_FRONTED
          }, 50)
        }
      } catch (err) {
        if (err.response?.data) {
          this.$notify({
            title: 'VALIDACIÓN',
            text: err.response.data.message,
            duration: 3500,
            type: 'error',
          })
        } else {
          this.$notify({
            title: 'VALIDACIÓN',
            text: 'Hubo un error al intentar registrarse, inténtalo nuevamente',
            duration: 3500,
            type: 'error',
          })
        }
      }
    }

    setTimeout(() => {
      const script3 = document.createElement('script')
      script3.src = 'https://accounts.google.com/gsi/client'
      document.body.appendChild(script3)
      script3.onload = () => {
        //  console.log('archivo.js cargado 3')
         }
    }, 50)
  },
}
</script>

<style>
.g_id_signin > div{
  display: flex;
  justify-content: center;
}
.icon-input {
  position: relative;
}
.icon-input input {
  padding-right: 40px;
}
.icon-input .showHidePassword {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
